import { render, staticRenderFns } from "./sme-policy-detail-info.vue?vue&type=template&id=37a5f4e6&scoped=true&"
import script from "./sme-policy-detail-info.vue?vue&type=script&lang=js&"
export * from "./sme-policy-detail-info.vue?vue&type=script&lang=js&"
import style0 from "./sme-policy-detail-info.vue?vue&type=style&index=0&id=37a5f4e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a5f4e6",
  null
  
)

export default component.exports